import PropTypes from 'prop-types';
import React from 'react';
import { Consumer as PageConsumer } from '../../contexts/PageContext';
import { EmitMetric } from '../Analytics/VisibilityPixel/VisibilityPixel';
import LoadingShineComponent from '../Content/Feed/LoadingShineComponent/LoadingShineComponent';
import { adTypes } from '../Includes/variables';
import CommonCardShell from '../Layout/CommonCardShell/CommonCardShell';
import EmployerReviewsBox from '../RightRail/EmployerReviewsBox/EmployerReviewsBox';
import JobsBox from '../RightRail/JobsBox/JobsBox';
import VirtualCareerFairCTA from '../JobV3/VirtualCareerFairCTA/VirtualCareerFairCTA';
import LeaveReviewCTA from '../CallToAction/LeaveReviewCTA/LeaveReviewCTA';

import './PromotionalAd.scss';

export default class PromotionalAd extends React.PureComponent {
    renderAd = (pageContext) => {
        if (!this.props.selectedAd) {
            return null;
        }

        if (this.props.selectedAd.isLoading) {
            return <LoadingShineComponent />;
        }

        if (!this.props.selectedAd.adInfo) {
            return null;
        }

        const { type, ad } = this.props.selectedAd.adInfo;

        switch (type) {
            case adTypes.LEAVE_REVIEW:
                return (
                    <CommonCardShell className="no-padding">
                        <LeaveReviewCTA
                            onClick={() => {
                                pageContext.toggleJobReviewSurvey(true);
                                EmitMetric({
                                    misc_event_count: 1,
                                    misc_event_type:
                                        'master-feed-review-ad-click',
                                });
                            }}
                            metrics={{
                                misc_event_count:
                                    'master-feed-review-ad-impression',
                            }}
                        />
                    </CommonCardShell>
                );

            case adTypes.VCF: {
                const { name, desktop, mobile, url } = ad;
                return (
                    <CommonCardShell>
                        <VirtualCareerFairCTA
                            cta={{
                                src: desktop,
                                mobileSrc: mobile,
                                alt: name,
                                url,
                            }}
                            metrics={{
                                clickTrigger: 'master-feed-vcf-ad-click',
                                misc_event_count:
                                    'master-feed-vcf-ad-impression',
                            }}
                        />
                    </CommonCardShell>
                );
            }
            // No longer shown
            case adTypes.COMPANY_REVIEWS:
                return (
                    <CommonCardShell>
                        <EmployerReviewsBox
                            reviews={ad.reviews ? ad.reviews : null}
                            hasFollowingCompanies={
                                ad.hasFollowingCompanies || false
                            }
                            toggleJobReviewSurvey={
                                pageContext.toggleJobReviewSurvey
                            }
                            pageProps={pageContext.pageProps}
                            wrapAuth={pageContext.wrapAuth}
                            isLoggedIn={pageContext.isLoggedIn}
                            modalTrigger={pageContext.modalTrigger}
                            metrics={{
                                clickTrigger:
                                    'mobile-master-feed-company-ad-click',
                                impression:
                                    'mobile-master-feed-company-ad-impression',
                            }}
                        />
                    </CommonCardShell>
                );

            case adTypes.SUGGESTED_JOBS:
                return (
                    <CommonCardShell>
                        <JobsBox
                            suggestedJobs={ad}
                            openModal={() =>
                                pageContext.modalTrigger('FollowedJobs')
                            }
                            metrics={{
                                clickTrigger:
                                    'mobile-master-feed-jobs-ad-click',
                                impression:
                                    'mobile-master-feed-jobs-ad-impression',
                            }}
                        />
                    </CommonCardShell>
                );

            default:
                return null;
        }
    };

    render() {
        return (
            <div className="component-PromotionalAd">
                <CommonCardShell className="no-padding">
                    <PageConsumer>
                        {(context) => this.renderAd(context)}
                    </PageConsumer>
                </CommonCardShell>
            </div>
        );
    }
}

PromotionalAd.propTypes = {
    selectedAd: PropTypes.objectOf(PropTypes.any),
};

PromotionalAd.defaultProps = {
    selectedAd: null,
};
